import { COUNTERPARTY_DATA_INITIAL_LOAD } from './action';

const counterpartyDataInitialValuesReducer = (state = {}, action) => {
    switch (action.type) {
        case COUNTERPARTY_DATA_INITIAL_LOAD:
            return {
                ...state,
                intialCounterpartyData: action.data
            }

        default:
            return state
    }
}

export default counterpartyDataInitialValuesReducer;